module.exports = __webpack_public_path__ + "img/upload-alt.69a1dc4e.svg";